<template>
  <!-- CPAP 機器返却管理 -->
  <div id="CpapReturnManagement">
    <div id="container">
      <div class="labelTitle lable">CPAP 機器返却管理</div>
      <!--検索条件 -->
      <div class="condition-area">
        <table class="conditionTable">
          <tr>
            <!--<th>受付番号<br/>(処方中止)</th>
            <td><input type="text"/></td>-->
            <th>機種</th>
            <td>
              <select>
              <option></option>
              <option>ドリームステーションAuto</option>
              <option>ドリームステーションGo</option>
              <option>ドリームステーションBiPAP Auto</option>
              <option>エスボックス バイスタルク</option>
              <option>プリズマライン(prisma25S)</option>
              </select>
            </td>
            <th>シリアル</th>
            <td><input type="text"/></td>
            <th>処方有無</th>
            <td><select><option></option><option>無</option><option>有</option></select></td>
            <th>医療機関名</th>
            <td><input type="text"/></td>
          </tr>
          <tr>
            <th>患者名</th>
            <td><input type="text"/></td>
            <th>遅延日数</th>
            <td><input type="text"/></td>
            <th>担当支店</th>
            <td>
              <select>
                <option value=""></option>
                <option v-for="item in branchOfficeMaster" :key="item.code" :value="item.code">{{item.name}}</option>
              </select>
            </td>
            <th>営業担当者</th>
            <td><input type="text"/></td>
          </tr>
        </table>
        <div class="searchButton-area">
          <b-button class="is-primary" @click="doSearch">検索</b-button>
        </div>
      </div>
      <!-- 検索結果 -->
      <div class="result-area"  v-if="hasResult">
        <div>
          <b-table
            id="requestFormListTable"
            :data="data"
            :paginated="isPaginated"
            per-page="100"
            pagination-position="both"
            default-sort="patientCode"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page"
          >
            <template slot-scope="props">
              <b-table-column field="patientCode" label="受付番号" width="100" centered sortable>
                <a @click="showDetail(props.row)">{{props.row.patientCode}}</a>
                <!--
                <a @click="showDetail(props.row.detailKind, props.row.progress,props.row)">{{props.row.patientCode}}</a>
                -->
              </b-table-column>
              <b-table-column field="kind" label="受付番号　　　　(処方中止)" width="100" sortable>{{props.row.kind}}</b-table-column>
              <b-table-column field="hospital" label="依頼元" width="180" sortable>{{props.row.hospital}}</b-table-column>
              <b-table-column field="hospital" label="医療機関名" width="180" sortable>{{props.row.hospital}}</b-table-column>
              <b-table-column field="patientName" label="患者名" width="100" sortable>{{props.row.patientName}}</b-table-column>
              <b-table-column field="branchOffice" label="申込日" width="80" sortable>{{props.row.requestDate}}</b-table-column>
              <b-table-column field="branchOffice" label="完了日" width="80" centered></b-table-column>
              <b-table-column field="branchOffice" label="申込み状況" width="80" centered>
                <span class="tag is-warning">
                  {{props.row.progress}}
                </span>
              </b-table-column>
              <b-table-column field="branchOffice" label="状態" width="80" centered>
                <span class="tag is-warning">
                  {{props.row.status}}
                </span>
              </b-table-column>
              <!--
              <b-table-column label="申込印刷" width="80" centered>
                <a @click="printDetail(props.row.detailKind,props.row)">
                <b-icon icon="printer"/></a>
              </b-table-column>
              <b-table-column label="報告書" width="60" centered  sortable>
                <template v-if="props.row.detailKind.indexOf('企業検診')==-1 && (props.row.progress==13 || props.row.progress==14 || props.row.progress==15)">
                  <a @click="showReportArea(props.row.reportFileList)"><b-icon icon="clipboard-file-outline" /></a>
                  <span v-if="showDownloadMark(props.row.reportFileList)" class="download"></span>
                </template>
              </b-table-column>
              -->
              <b-table-column label="問い合わせ" width="80" centered>
                <a>
                  <b-icon icon="email-outline"/>
                </a>
              </b-table-column>
            </template>
          </b-table>
        </div>
      </div>
    </div>
    <!--
    <floatingDiv v-if="isShowHstDetail" @close="closeDetail" title="" width="640px" height="480px" :top="dialogTopPostion" right="100px">
      <hstRequestDetail :data="showDetailTargetData"/>
    </floatingDiv>
    -->
  </div>
</template>
<script>
const sampleData = require('@/sampledata/CpapRequestList.json')

import {role} from "@/components/mock/base/const.js";
import {choicesType} from "@/components/mock/base/const.js";
import {requestStatus} from "@/components/mock/base/const.js";
import floatingDiv from "@/components/mock/common/FloatingDiv";
//import CpapRequestDetail from "@/components/mock/common/CpapRequestDetail";

export default {
  name: "CpapReturnManagement",
  methods: {
    reSearch: function() {
      this.reSearchFlag = true
      this.doSearch()
    },
    doSearch: function() {
      this.hasResult = true;
    },
    showDetail: function(kind, progress, rowData) {
      this.$router.push({ path: "/philips/cpap/RequestDetail" });
    },
    showModal: function(item){
      //this.selectedData = this.getCopy(item);
      //this.returnDelayedDetailModalActive = true;
    },
  },
  data() {
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var roleId = userInfo.roleId;
    var userId = userInfo.id;
    var isDealer = roleId == role.role_dealer;
    var isSalesOffice = roleId == role.role_salesOffice;
    var isHospital = roleId == role.role_hospital;
    var isHonsha = roleId == role.role_headOffice;
    var isAdmin = roleId == role.role_admin;

    let kindList = this.getKindGroup()
    let statusList = this.getStatusList();
    let salesOfficeMaster = this.getSalesOfficeMaster();
    let branchOfficeMaster = this.getBranchOfficeMaster();
    let blockMaster = this.getBlockMaster();
    return {
      data: sampleData,
      roleId: roleId,
      userId: userId,
      isDealer: isDealer,
      isSalesOffice: isSalesOffice,
      isHonsha: isHonsha,
      isAdmin: isAdmin,
      role: role,
      choicesType:choicesType,
      statusList,
      salesOfficeMaster,
      branchOfficeMaster,
      blockMaster,
      isPaginated : true,
      hasResult: false,
    };
  },
  filters: {},
  components: { 
    //floatingDiv: floatingDiv,
  },
  async mounted() {
  }
};
</script>
<style lang="scss" scoped>
a {
  text-decoration: underline;
}
input {
  width: 200px;
}
select {
  width: 200px;
}
.tag {
  width: 100px;
}
.selectColumn {
  width: 800px;
  position: absolute;
  background-color: white;
  z-index: 25;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/cpap/CpapReturnManagement.vue